import {useTranslation} from "react-i18next";

export default function ProductError({message}: { message: string }) {
    const {t} = useTranslation();

    return (
        <div className={'error-product-list'}>
            <p>{message}</p>
            <button>{t("tryAgain")}</button>
        </div>
    )
}